import { Check, Close, Error, Info, Warning } from '@mui/icons-material'
import { Grid, IconButton } from '@mui/material'
import {
  closeSnackbar,
  type CustomContentProps,
  SnackbarContent,
} from 'notistack'
import { forwardRef, memo } from 'react'

import { useAppSnackbarProviderStyles } from './AppSnackbarProvider.styles'

const HubloSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => {
    const { variant, message, id } = props
    const { cx, classes } = useAppSnackbarProviderStyles()

    const icons = {
      success: <Check className={classes.icon} />,
      warning: <Warning className={classes.icon} />,
      error: <Error className={classes.icon} />,
      info: <Info className={classes.icon} />,
    }

    const onClickDismiss = () => {
      closeSnackbar(id)
    }

    return (
      <SnackbarContent
        ref={ref}
        role="alert"
        className={cx([classes.variantRoot, classes[variant]])}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          wrap={'nowrap'}
        >
          {icons[variant]}
          <Grid item>{message}</Grid>
        </Grid>
        <IconButton aria-label="close" color="inherit" onClick={onClickDismiss}>
          <Close />
        </IconButton>
      </SnackbarContent>
    )
  },
)

export default memo(HubloSnackbar)
